<template>
  <div :ref="id" class="cockpitModalContianer" v-show="value">
    <div @click="maskCloseModal" class="cockpitModalMask" v-if="showMask"></div>
    <div
      :class="'cockpitModal cockpitModal-'+ type + ' ' + extClass + (fullScreen?' fullCockpitModal':'') "
    >
      <div :style="{width: width, height: height}" class="cockpitModalContent">
        <div class="cockpitModalHeader">
          <div class="panelHeaderTitle">{{title}}</div>
          <div @click="closeModal" class="closeIcon"></div>
        </div>
        <div class="cockpitModalBody">
          <slot name="content">content</slot>
          <div class="modalFooter">
            <slot name="modalFooter"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cockpitModal',
  props: {
    title: '',
    value: {
      required: true,
    },
    fullScreen: {
      required: false,
      default: false
    },
    extClass: {
      required: false,
      default: ''
    },
    type: {
      required: false,
      default: 'default'
    },
    showMask: {
      required: false,
      default: true
    },
    maskClose: {
      required: false,
      default: true
    },
    width: {
      required: false,
      default: ''
    },
    height: {
      required: false,
      default: ''
    }
  },
  watch: {
    value: {
      handler (old, newValue) {
        console.log(old, newValue)
      }
    }
  },
  data () {
    return {
      id: 'cockpitModal-' + new Date().getTime()
    }
  },
  methods: {
    maskCloseModal: function () {
      if (this.maskClose) {
        this.$emit('on-cancel')
      }
    },
    closeModal: function () {
      this.$emit('on-cancel')
    }
  }
}
</script>
<style lang='less'>
.cockpitModalContianer {
  z-index: 999;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  pointer-events: visible;
  /* padding: 0.5rem; */

  .cockpitModalMask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(1, 1, 1, 0.6);
  }

  .cockpitModal.cockpitModal-default {
    background-image: url('data:image/png;base64,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');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .cockpitModalContent {
      background: -webkit-gradient(
        linear,
        left top,
        left bottom,
        from(rgba(0, 68, 255, 0.6)),
        to(rgba(0, 0, 0, 0.6))
      );
      background: linear-gradient(
        180deg,
        rgba(0, 68, 255, 0.6) 0%,
        rgba(0, 0, 0, 0.6) 100%
      );

      .cockpitModalHeader {
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 500;
        color: #f0faff;
        padding: 0 3rem;
        position: relative;

        .panelHeaderTitle {
          padding: 1rem 2.5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
          max-width: 100%;
          width: fit-content;
          margin: auto;
          position: relative;
          color: #0bc7ea;
          font-size: 1.4rem;
          font-weight: 400;
        }

        .panelHeaderTitle::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 2rem;
          height: 1rem;
          background-image: url('./static/images/modal/title.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .panelHeaderTitle::after {
          content: '';
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 2rem;
          height: 1rem;
          background-image: url('./static/images/modal/title.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          transform: rotateY(180deg);
        }

        .closeIcon {
          cursor: pointer;
          background-image: url('./static/images/modal/close.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 1rem;
          height: 1rem;
          min-width: fit-content;
          position: absolute;
          right: 1.5rem;
          top: 0;
          bottom: 0;
          margin: auto;
          opacity: 0.8;
        }

        .closeIcon:hover {
          opacity: 1;
        }
      }

      .cockpitModalBody {
        position: relative;
        padding: 8px;
        overflow: hidden;
        min-height: 100px;
        flex-grow: 1;
        color: #fff;
      }
    }
  }

  .cockpitModal.cockpitModal-sample {
    min-width: 320px;

    .cockpitModalHeader {
      position: relative;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-weight: 500;
      color: #f0faff;
      padding: 0;
      line-height: 2rem;
      position: absolute;
      top: -1.4rem;
      left: 0;
      right: 0;
      z-index: 999;

      .panelHeaderTitle {
        padding: 0 1.8rem;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        max-width: 100%;
        width: fit-content;
        position: relative;
        color: #0bc7ea;
        width: 24%;
        left: 1%;
      }

      .panelHeaderTitle::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 1.6rem;
        height: 0.8rem;
        background-image: url('./static/images/modal/title.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .panelHeaderTitle::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 1.6rem;
        height: 0.8rem;
        background-image: url('./static/images/modal/title.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        transform: rotateY(180deg);
      }

      .closeIcon {
        cursor: pointer;
        background-image: url('./static/images/modal/close.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 0.8rem;
        height: 0.8rem;
        min-width: fit-content;
        position: absolute;
        right: 0;
        top: 1.6rem;
        bottom: 0;
        margin: auto;
        opacity: 0.8;
      }

      .closeIcon:hover {
        opacity: 1;
      }
    }

    .cockpitModalBody {
      position: relative;
      padding: 8px;
      overflow: hidden;
      min-height: 200px;
      flex-grow: 1;
      background-image: url('data:image/png;base64,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');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-top: 6%;

      .flexDataContainer {
        width: 50vw;
        min-width: 320px;
        display: flex;
      }

      .flexDataContainer > div {
        flex: 1;
        overflow: hidden;
        font-size: 0.85rem;
        line-height: 2rem;
      }

      .infoItem {
        display: flex;
        align-items: center;
        white-space: nowrap;
      }

      .label {
        font-size: 0.8rem;
        width: 50%;
        min-width: 50%;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .value {
        font-size: 0.8rem;
        width: 50%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .modalFooter {
        text-align: right;
        padding: 0.5rem;

        .ivu-btn-primary {
          background-color: #09e0ee;
          border-color: #09e0ee;
        }

        .ivu-btn-ghost.ivu-btn-primary {
          color: #09e0ee;
          background-color: transparent;
        }
      }
    }
  }

  .cockpitModal {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: fit-content;
    width: fit-content;
    max-height: 100vh;
    max-width: 100vw;

    .cockpitModalContent {
      width: 100%;
      height: 100%;
      max-height: 100vh;
      max-width: 100vw;
      min-width: 320px;
      // min-height: 300px;
      display: flex;
      flex-direction: column;

      .ivu-divider-horizontal.ivu-divider-with-text-center,
      .ivu-divider-horizontal.ivu-divider-with-text-left,
      .ivu-divider-horizontal.ivu-divider-with-text-right {
        color: #fff;
      }

      .ivu-table {
        background-color: transparent !important;

        td,
        th {
          background-color: transparent !important;
          color: #fff;
          border: none;
        }
      }

      .ivu-table:before {
        content: none;
      }

      .modalTab {
        // width: 80%;
        margin: auto;

        .ivu-tabs {
          width: 100%;

          .ivu-tabs-bar {
            margin-bottom: 1rem;
          }
          .ivu-tabs-ink-bar {
            height: 0;
          }
        }

        .ivu-tabs-nav-scrollable {
          padding: 0 2.4rem;
        }

        .ivu-tabs-nav-next,
        .ivu-tabs-nav-prev {
          line-height: 4rem;
        }

        .ivu-tabs-nav-prev > i::before {
          content: '';
          width: 1.6rem;
          height: 1.6rem;
          display: inline-block;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          transform: rotateY(180deg);
          background-image: url('./static/images/modal/tab.png');
        }

        .ivu-tabs-nav-next > i::before {
          content: '';
          width: 1.6rem;
          height: 1.6rem;
          display: inline-block;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-image: url('./static/images/modal/tab.png');
        }

        .ivu-tabs-tab {
          // height: 2.6rem;
          color: #fff;
          line-height: 2.6rem;
          font-size: 0.9rem;

          border-bottom: none;
          padding: 0.4rem 2.6rem;
        }

        .ivu-tabs-nav .ivu-tabs-tab-active {
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-image: url('./static/images/modal/label1.png');
        }
      }

      .modalFooter {
        text-align: right;
      }

      .ivu-select-selection,
      .ivu-input {
        color: #fff;
        border: 1px solid #2d8cf0 !important;
      }

      .ivu-select-input {
        color: #fff;
      }
    }
  }

  .cockpitModal.fullCockpitModal {
    width: 100vw !important;
    height: 100vh !important;
    min-width: 100vw !important;
    min-height: 100vh !important;

    .cockpitModalContent {
      width: 100vw !important;
      height: 100vh !important;
      min-width: 100vw !important;
      min-height: 100vh !important;
    }
  }
}
</style>